import React from 'react';

import rightArrow from '../../assets/images/gallery-right.png';

const RightArrow = props => {
  // console.log('props: ', props);
  return (
    <div
      className={`${props.className} nextArrow br-100 flex justify-center`}
      style={{
        width: '80px',
        height: '80px'
      }}
      onClick={props.goToNextSlide}
    >
      <img src={rightArrow} alt="right-arrow" />
    </div>
  );
};

export default RightArrow;
